import { MDSShortcutKeyCharacter } from "./shortcut-key.types";

export const MDSShortcutKeyCharacterMapping: Record<MDSShortcutKeyCharacter, string> = {
  [MDSShortcutKeyCharacter.Command]: "⌘",
  [MDSShortcutKeyCharacter.C]: "C",
  [MDSShortcutKeyCharacter.Slash]: "/",
  [MDSShortcutKeyCharacter.Hashtag]: "#",
  [MDSShortcutKeyCharacter.Period]: ".",
  [MDSShortcutKeyCharacter.One]: "1",
  [MDSShortcutKeyCharacter.Space]: "Space",
  [MDSShortcutKeyCharacter.Dash]: "-",
  [MDSShortcutKeyCharacter.TabArrow]: "⇥",
  [MDSShortcutKeyCharacter.Pipe]: "|",
  [MDSShortcutKeyCharacter.Backtick]: "`",
  [MDSShortcutKeyCharacter.GreaterThan]: ">",
  [MDSShortcutKeyCharacter.Enter]: "⮐",
  [MDSShortcutKeyCharacter.SquareBracketOpen]: "[",
  [MDSShortcutKeyCharacter.SquareBracketClose]: "]",
  [MDSShortcutKeyCharacter.Tab]: "Tab",
  [MDSShortcutKeyCharacter.Escape]: "Esc",
  [MDSShortcutKeyCharacter.Option]: "⌥",
  [MDSShortcutKeyCharacter.Ctrl]: "Ctrl",
} as const;
